import _ from "lodash";

export const checkFilesEquality = (previous: any[], current: any[]) => {
  const importantProps = ['fileName', 'repositoryTicket', 'targetLanguages', 'uploaded'];
  const oldFiles = previous.map((item: any) => _.pick(item, importantProps));
  const newFiles = current.map((item: any) => _.pick(item, importantProps));

  return _.isEqual(oldFiles, newFiles)
};
